/**
 * Single source of truth for site navigation.
 *
 * Imported by BOTH the React shell (Header.jsx, Footer.jsx) and the static
 * Library generator (scripts/library/lib/shell.mjs). Add a nav item once and
 * it appears in the SPA header, the SPA mobile menu, the static Library
 * header and the footer — there is no second list to keep in step.
 *
 * `.mjs` is deliberate: Node imports it directly with no transpile step, and
 * webpack 5 resolves it inside the CRA bundle. Keep this file free of
 * imports so both loaders stay happy.
 *
 * `isStatic: true` marks a target that is pre-rendered HTML on disk rather
 * than a react-router route. Those MUST render as a plain <a href> in the
 * SPA — a <Link> would be intercepted by the router, match path="*" and
 * render the 404 page.
 */

export const productLinks = [
  {
    to: "/payroll",
    label: "KedByte Payroll",
    desc: "UK payroll for bureaux & accountants — in development",
  },
  {
    to: "/quill",
    label: "KedByte Quill",
    desc: "School records software — in development",
  },
];

export const primaryLinks = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { label: "Products", children: productLinks },
  { to: "/library/", label: "Library", isStatic: true },
  { to: "/about", label: "About" },
  { to: "/careers", label: "Careers" },
];

/** Appended to the mobile menu only. */
export const mobileExtraLinks = [{ to: "/contact", label: "Contact" }];

export const footerCols = [
  {
    title: "Company",
    links: [
      { to: "/", label: "Home" },
      { to: "/about", label: "About" },
      { to: "/careers", label: "Careers" },
      { to: "/services", label: "Services" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { to: "/services#service-1", label: "Custom Software & Apps" },
      { to: "/services#service-2", label: "Frontend & Backend" },
      { to: "/services#service-3", label: "AI & Machine Learning" },
      { to: "/services#service-4", label: "Blockchain & Web3" },
      { to: "/services#service-5", label: "DevOps & Automation" },
      { to: "/services#service-6", label: "UI/UX Design" },
    ],
  },
];

export const footerProducts = [
  { to: "/payroll", label: "KedByte Payroll", testid: "footer-payroll-link" },
  { to: "/quill", label: "KedByte Quill", testid: "footer-schoolos-link" },
  {
    to: "/library/",
    label: "KedByte Library",
    testid: "footer-library-link",
    isStatic: true,
  },
];

/** Legal identity as it appears in the site footer. */
export const company = {
  name: "KedByte Technologies Private Limited",
  email: "techteam@kedbyte.com",
  city: "Vadodara",
  region: "Gujarat",
  country: "India",
  incorporated: "08 May 2026",
};
